import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import {
  Text,
  paletteHelper,
  Stack,
  typographyHelper,
  spacingHelper,
  mediaHelper,
} from '@property.com.au/ui-kit';

interface LocationPageTitle {
  overline?: string;
  title: string;
  subtitle?: string | null;
}

const Overline = styled(Text).attrs(() => ({
  forwardedAs: 'span',
}))`
  padding-top: ${spacingHelper('medium')};
  ${mediaHelper('desktopMin')} {
    padding-top: ${spacingHelper('twoExtraLarge')};
  }
  line-height: 100%;
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};
`;

const Title = styled(Text).attrs(() => ({
  forwardedAs: 'span',
  variant: 'title01',
}))`
  line-height: 100%;
`;

const Subtitle = styled(Text).attrs(() => ({
  forwardedAs: 'span',
}))`
  line-height: 100%;
  ${typographyHelper('title03Light')}
  color: ${paletteHelper('textSecondary')};
`;

export const LocationPageTitle: FunctionComponent<LocationPageTitle> = ({
  overline,
  title,
  subtitle,
}) => {
  return (
    <Stack as="h1" gap="extraSmall">
      {overline && <Overline>{overline}</Overline>}
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Stack>
  );
};
